import React from "react";
import { Container, Col, Row } from "reactstrap";
import BackgroundCentered from "../../components/BackgroundCentered";
const Contact = () => {
  return <BackgroundCentered />;
};

export default Contact;
